import { LogicConstants } from "../ds/LogicConstants.js";
import { isEmptyString,isEmptyArray } from "../gui_components/Util.js";
import moment from "moment";


export class ModuleUtils {
  constructor() {
    this.invoiceStatusList = [];
    this.getInvoiceStatusList();
    this.arStatusList = [];
    this.getARStatusList();
    this.creditMemoStatusList = [];
    this.getCreditMemoStatusList();
    this.creditMemoLineStatusList = [];
    this.getCreditMemoLineStatusList();
    this.salesOrderStatusList = [];
    this.getSalesOrderStatusList();
    this.salesOrderLineStatusList = [];
    this.getSalesOrderLineStatusList();
    this.purchaseOrderStatusList = [];
    this.getPurchaseOrderStatusList();
    this.purchaseOrderLineStatusList = [];
    this.getPurchaseOrderLineStatusList();
    this.purchaseOrderReceiptStatusList = [];
    this.getPurchaseOrderReceiptStatusList();
    this.purchaseOrderReceiptLineStatusList = [];
    this.getPurchaseOrderReceiptLineStatusList();
    this.purchaseOrderInTransitStatusList = [];
    this.getPurchaseOrderInTransitStatusList();
    this.purchaseOrderInTransitLineStatusList = [];
    this.getPurchaseOrderInTransitLineStatusList();
    this.pickTicketStatusList = [];
    this.getPickTicketStatusList();
    this.checkTransactionStatusList = [];
    this.getCheckTransactionStatusList();
    this.vendorInvoiceStatusList = [];
    this.getVendorInvoiceStatusList();
    this.depositStatusList = [];
    this.getDepositStatusList();
    this.bankAdjustmentStatusList = [];
    this.getBankAdjustmentStatusList();
    this.letterOfCreditStatusList = [];
    this.getLetterOfCreditStatusList();
    this.checkBounceStatusList = [];
    this.getCheckBounceStatusList();
    this.customerReturnStatusList = [];
    this.getCustomerReturnStatusList();
    this.preProductionStageStatusList = [];
    this.getPreProductionStageStatusList();
    this.preProductionCycleStatusList = [];
    this.getPreProductionCycleStatusList();
    this.preProductionStatusList = [];
    this.getPreProductionStatusList();
    this.ecomWebOrderStatusList = [];
    this.getEcomWebOrderJobStatusList();
    this.logisticOrderStatusList = [];
    this.getLogisticOrderStatusList();
    this.logisticOrderLineStatusList = [];
    this.getLogisticOrderLineStatusList();
    this.logisticOrderReceiptStatusList = [];
    this.getLogisticOrderReceiptStatusList();
    this.logisticOrderReceiptLineStatusList = [];
    this.getLogisticOrderReceiptLineStatusList();
    this.invoiceServiceLineStatusList = [];
    this.getInvoiceServiceLineStatusList();
    this.postDatedCheckStatusList = [];
    this.getPostDatedCheckEntryStatusList();



    this.purchaseOrderPaymentStatusList = [];
    this.getPurchaseOrderPaymentStatusList();



    this.purchaseOrderReceiptPaymentStatusList = [];
    this.getPurchaseOrderReceiptPaymentStatusList();
	
	
    this.cpmStatusList = [];
    this.getCpmStatusList();
    this.cpmLineStatusList = [];
    this.cpmLinesStatusList();

    this.debitMemoStatusList = [];
    this.getDebitMemoStatusList();
    this.debitMemoLineStatusList = [];
    this.getDebitMemoLinesStatusList();


    this.debitMemoTrackStatusList = [];
    this.getDebitMemoTrackStatusList();
  }
  //#region  Invoice Status Related
  static getInvoiceStatusList = () => {
    this.invoiceStatusList = [];
    this.invoiceStatusList[LogicConstants.INVOICE_UNAPPROVE_STATUS] =
      "UNAPPROVED";
    this.invoiceStatusList[LogicConstants.INVOICE_OPEN_STATUS] = "OPEN";
    this.invoiceStatusList[LogicConstants.INVOICE_APPROVE_STATUS] = "APPROVED";
    this.invoiceStatusList[LogicConstants.INVOICE_PAID_STATUS] = "PAID";
    this.invoiceStatusList[LogicConstants.INVOICE_PARTIALLY_PAID_STATUS] =
      "PARTIALLY PAID";
    this.invoiceStatusList[LogicConstants.INVOICE_CANCEL_STATUS] = "CANCELLED";
    return this.invoiceStatusList;
  };
  static getInvoiceBeanStatusList = () => {
    let statusList = [];
    return statusList;
  };
  static getInvoiceStatusCaption = (status) => {
    if (isEmptyString(status)) return "";
    if (this.invoiceStatusList === undefined) return "";
    return this.invoiceStatusList[status];
  };
  //#endregion
  //#region  AR Status Related
  static getARStatusList = () => {
    this.arStatusList = [];
    this.arStatusList[LogicConstants.ACCOUNT_RECEIVABLE_OPEN_STATUS] = "OPEN";
    this.arStatusList[LogicConstants.ACCOUNT_RECEIVABLE_FINISHED_STATUS] =
      "FINISHED";
    this.arStatusList[LogicConstants.ACCOUNT_RECEIVABLE_CANCEL_STATUS] =
      "CANCELLED";
    this.arStatusList[LogicConstants.ACCOUNT_RECEIVABLE_REVERSE_STATUS] =
      "REVERSED";
    return this.arStatusList;
  };
  static getARBeanStatusList = () => {
    let statusList = [];
    return statusList;
  };
  static getARStatusCaption = (status) => {
    if (isEmptyString(status)) return "";
    if (this.arStatusList === undefined) return "";
    return this.arStatusList[status];
  };
  //#endregion
  //#region  CreditMemo Status Related
  static getCreditMemoStatusList = () => {
    this.creditMemoStatusList = [];
    this.creditMemoStatusList[LogicConstants.CREDIT_MEMO_OPEN_STATUS] = "OPEN";
    this.creditMemoStatusList[LogicConstants.CREDIT_MEMO_UNAPPROVE_STATUS] =
      "UNAPPROVED";
    this.creditMemoStatusList[LogicConstants.CREDIT_MEMO_APPROVE_STATUS] =
      "APPROVED";
    this.creditMemoStatusList[LogicConstants.CREDIT_MEMO_FINISHED_STATUS] =
      "PAID";
    this.creditMemoStatusList[
      LogicConstants.CREDIT_MEMO_PARTIALLY_CLOSED_STATUS
    ] = "PARTIALLYPAID";
    this.creditMemoStatusList[LogicConstants.CREDIT_MEMO_CANCEL_STATUS] =
      "CANCELLED";
    return this.creditMemoStatusList;
  };
  static getCreditMemoBeanStatusList = () => {
    let statusList = [];
    return statusList;
  };
  static getCreditMemoStatusCaption = (status) => {
    if (isEmptyString(status)) return "";
    if (this.creditMemoStatusList === undefined) return "";
    return this.creditMemoStatusList[status];
  };
  //#endregion
  //#region CreditMemo Line
  static getCreditMemoLineStatusList = () => {
    this.creditMemoLineStatusList = [];
    this.creditMemoLineStatusList[LogicConstants.CREDIT_MEMO_LINE_OPEN_STATUS] =
      "OPEN";
    this.creditMemoLineStatusList[
      LogicConstants.CREDIT_MEMO_LINE_APPROVE_STATUS
    ] = "APPROVED";
    this.creditMemoLineStatusList[
      LogicConstants.CREDIT_MEMO_LINE_CANCEL_STATUS
    ] = "CANCEL";

    return this.creditMemoLineStatusList;
  };
  static getCreditMemoLineBeanStatusList = () => {
    let statusList = [];
    return statusList;
  };
  static getCreditMemoLineStatusCaption = (status) => {
    if (isEmptyString(status)) return "";
    if (this.creditMemoLineStatusList === undefined) return "";
    return this.creditMemoLineStatusList[status];
  };
  //#endregion
  static getSalesOrderStatusList = () => {
    this.salesOrderStatusList = [];
    this.salesOrderStatusList[LogicConstants.SALES_ORDER_UNAPPROVE_STATUS] =
      "UNAPPROVED";
    this.salesOrderStatusList[LogicConstants.SALES_ORDER_APPROVE_STATUS] =
      "APPROVED";
    this.salesOrderStatusList[LogicConstants.SALES_ORDER_CANCEL_STATUS] =
      "CANCELLED";
    this.salesOrderStatusList[LogicConstants.SALES_ORDER_CLOSE_STATUS] =
      "CLOSED";
    this.salesOrderStatusList[LogicConstants.SALES_ORDER_INVOICED_STATUS] =
      "FINISHED";
    this.salesOrderStatusList[LogicConstants.SALES_ORDER_PICKED_STATUS] =
      "PICKED";
    this.salesOrderStatusList[
      LogicConstants.SALES_ORDER_PARTIALLY_PICKED_STATUS
    ] = "PARTIALLY PICKED";
    this.salesOrderStatusList[
      LogicConstants.SALES_ORDER_PARTIALLY_INVOICED_STATUS
    ] = "PARTIALLY INVOICED";
    return this.salesOrderStatusList;
  };
  static getSalesOrderBeanStatusList = () => {
    let statusList = [];
    return statusList;
  };
  static getSalesOrderStatusCaption = (status) => {
    if (isEmptyString(status)) return "";
    if (this.salesOrderStatusList === undefined) return "";
    return this.salesOrderStatusList[status];
  };
  //#endregion
  static getSalesOrderLineStatusList = () => {
    this.salesOrderLineStatusList = [];
    this.salesOrderLineStatusList[LogicConstants.SALES_ORDER_LINE_OPEN_STATUS] =
      "Open";
    this.salesOrderLineStatusList[
      LogicConstants.SALES_ORDER_LINE_APPROVE_STATUS
    ] = "APPROVED";
    this.salesOrderLineStatusList[
      LogicConstants.SALES_ORDER_LINE_CANCEL_STATUS
    ] = "CANCELLED";
    this.salesOrderLineStatusList[
      LogicConstants.SALES_ORDER_LINE_CLOSE_STATUS
    ] = "CLOSED";
    this.salesOrderLineStatusList[
      LogicConstants.SALES_ORDER_LINE_SHIPPED_STATUS
    ] = "FINISHED";
    this.salesOrderLineStatusList[
      LogicConstants.SALES_ORDER_LINE_PACKED_STATUS
    ] = "PICKED";
    this.salesOrderLineStatusList[
      LogicConstants.SALES_ORDER_LINE_PARTIALLY_PACKED_STATUS
    ] = "PARTIALLY PICKED";
    this.salesOrderLineStatusList[
      LogicConstants.SALES_ORDER_LINE_PACKED_CANCEL_STATUS
    ] = "Picked & Cancelled";
    this.salesOrderLineStatusList[
      LogicConstants.SALES_ORDER_LINE_PACKED_CLOSE_STATUS
    ] = "Picked & Closed";
    this.salesOrderLineStatusList[
      LogicConstants.SALES_ORDER_LINE_SHIPED_CANCEL_STATUS
    ] = "Invoiced & Cancelled";
    this.salesOrderLineStatusList[
      LogicConstants.SALES_ORDER_LINE_SHIPED_CLOSE_STATUS
    ] = "Invoiced & Closed";
    this.salesOrderLineStatusList[
      LogicConstants.SALES_ORDER_LINE_PARTIALLY_SHIPPED_STATUS
    ] = "Partially Invoiced";
    return this.salesOrderLineStatusList;
  };
  static getSalesOrderLineBeanStatusList = () => {
    let statusList = [];
    return statusList;
  };
  static getSalesOrderLineStatusCaption = (status) => {
    if (isEmptyString(status)) return "";
    if (this.salesOrderLineStatusList === undefined) return "";
    return this.salesOrderLineStatusList[status];
  };
  //#region  PickTicket Status Related
  static getPickTicketStatusList = () => {
    this.pickTicketStatusList = [];
    this.pickTicketStatusList[LogicConstants.PICK_TICKET_UNAPPROVE_STATUS] =
      "UNAPPROVED";
    this.pickTicketStatusList[LogicConstants.PICK_TICKET_APPROVE_STATUS] =
      "APPROVED";
    this.pickTicketStatusList[LogicConstants.PICK_TICKET_CANCEL_STATUS] =
      "CANCELLED";
    // this.pickTicketStatusList[LogicConstants.PICK_TICKET_CLOSE_STATUS] =
    //   "CLOSED";
    this.pickTicketStatusList[LogicConstants.PICK_TICKET_INVOICED_STATUS] =
      "INVOICED";
    this.pickTicketStatusList[LogicConstants.PICK_TICKET_PICKED_STATUS] =
      "PICKED";
    this.pickTicketStatusList[
      LogicConstants.PICK_TICKET_PARTIALLY_PICKED_STATUS
    ] = "PARTIALLY PICKED";
    this.pickTicketStatusList[
      LogicConstants.PICK_TICKET_PARTIALLY_INVOICED_STATUS
    ] = "PARTIALLY INVOICED";
    return this.pickTicketStatusList;
  };
  static getPickTicketBeanStatusList = () => {
    let statusList = [];
    return statusList;
  };
  static getPickTicketStatusCaption = (status) => {
    if (isEmptyString(status)) return "";
    if (this.pickTicketStatusList === undefined) return "";
    return this.pickTicketStatusList[status];
  };
  static getVendorInvoiceStatusList = () => {
    this.vendorInvoiceStatusList = [];
    this.vendorInvoiceStatusList[LogicConstants.VENDOR_INVOICE_OPEN_STATUS] =
      "OPEN";
    this.vendorInvoiceStatusList[LogicConstants.VENDOR_INVOICE_CANCEL_STATUS] =
      "CANCELLED";
    this.vendorInvoiceStatusList[LogicConstants.VENDOR_INVOICE_PAID_STATUS] =
      "PAID";
    this.vendorInvoiceStatusList[
      LogicConstants.VENDOR_INVOICE_UNAPPROVE_STATUS
    ] = "UNAPPROVED";
    this.vendorInvoiceStatusList[LogicConstants.VENDOR_INVOICE_APPROVE_STATUS] =
      "APPROVED";
    this.vendorInvoiceStatusList[
      LogicConstants.VENDOR_INVOICE_PARTIALLY_PAID_STATUS
    ] = "PARTIALLY PAID";
    return this.vendorInvoiceStatusList;
  };
  static getVendorInvoiceBeanStatusList = () => {
    let statusList = [];
    return statusList;
  };
  static getVendorInvoiceStatusCaption = (status) => {
    if (isEmptyString(status)) return "";
    if (this.vendorInvoiceStatusList === undefined) return "";
    return this.vendorInvoiceStatusList[status];
  };
  static getCheckTransactionStatusList = () => {
    this.checkTransactionStatusList = [];
    this.checkTransactionStatusList[
      LogicConstants.CHECK_TRANSACTION_OPEN_STATUS
    ] = "OPEN";
    this.checkTransactionStatusList[
      LogicConstants.CHECK_TRANSACTION_PRINTED_STATUS
    ] = "PRINTED";
    this.checkTransactionStatusList[
      LogicConstants.CHECK_TRANSACTION_VOIDED_STATUS
    ] = "VOIDED";
    return this.checkTransactionStatusList;
  };
  static getCheckTransactionBeanStatusList = () => {
    let statusList = [];
    return statusList;
  };
  static getCheckTransactionStatusCaption = (status) => {
    if (isEmptyString(status)) return "";
    if (this.checkTransactionStatusList === undefined) return "";
    return this.checkTransactionStatusList[status];
  };
  static getPurchaseOrderStatusList = () => {
    this.purchaseOrderStatusList = [];
    this.purchaseOrderStatusList[
      LogicConstants.PURCHASE_ORDER_UNAPPROVE_STATUS
    ] = "UNAPPROVED";
    this.purchaseOrderStatusList[LogicConstants.PURCHASE_ORDER_APPROVE_STATUS] =
      "APPROVED";
    this.purchaseOrderStatusList[LogicConstants.PURCHASE_ORDER_CANCEL_STATUS] =
      "CANCELLED";
    this.purchaseOrderStatusList[
      LogicConstants.PURCHASE_ORDER_RECEIVED_STATUS
    ] = "RECEIVED";
    this.purchaseOrderStatusList[
      LogicConstants.PURCHASE_ORDER_PARTIALLY_RECEIVED_STATUS
    ] = "PARTIALLY RECEIVED";
    this.purchaseOrderStatusList[
      LogicConstants.PURCHASE_ORDER_FORCE_CLOSED_STATUS
    ] = "FORCE CLOSED";
    return this.purchaseOrderStatusList;
  };
  static getPurchaseOrderBeanStatusList = () => {
    let statusList = [];
    return statusList;
  };
  static getPurchaseOrderStatusCaption = (status) => {
    if (isEmptyString(status)) return "";
    if (this.purchaseOrderStatusList === undefined) return "";
    return this.purchaseOrderStatusList[status];
  };
  static getPurchaseOrderLineStatusList = () => {
    this.purchaseOrderLineStatusList = [];
    this.purchaseOrderLineStatusList[
      LogicConstants.PURCHASE_ORDER_LINE_OPEN_STATUS
    ] = "OPEN";
    this.purchaseOrderLineStatusList[
      LogicConstants.PURCHASE_ORDER_LINE_CANCEL_STATUS
    ] = "CANCELLED";
    this.purchaseOrderLineStatusList[
      LogicConstants.PURCHASE_ORDER_LINE_RECEIVED_STATUS
    ] = "RECEIVED";
    this.purchaseOrderLineStatusList[
      LogicConstants.PURCHASE_ORDER_LINE_CLOSE_STATUS
    ] = "CLOSED";
    this.purchaseOrderLineStatusList[
      LogicConstants.PURCHASE_ORDER_LINE_RECEIVED_CANCEL_STATUS
    ] = "RECEIVED CANCELLED";
    this.purchaseOrderLineStatusList[
      LogicConstants.PURCHASE_ORDER_LINE_RECEIVED_CLOSE_STATUS
    ] = "RECEIVED CLOSED";
    this.purchaseOrderLineStatusList[
      LogicConstants.PURCHASE_ORDER_LINE_PARTIALLY_RECEIVED
    ] = "PARTIALLY RECEIVED";
    return this.purchaseOrderLineStatusList;
  };
  static getPurchaseOrderLineBeanStatusList = () => {
    let statusList = [];
    return statusList;
  };
  static getPurchaseOrderLineStatusCaption = (status) => {
    if (isEmptyString(status)) return "";
    if (this.purchaseOrderLineStatusList === undefined) return "";
    return this.purchaseOrderLineStatusList[status];
  };
  //#endregion
  static getPurchaseOrderReceiptStatusList = () => {
    this.purchaseOrderReceiptStatusList = [];
    this.purchaseOrderReceiptStatusList[
      LogicConstants.PURCHASEORDER_RECEIPT_UNAPPROVE_STATUS
    ] = "UNAPPROVED";
    this.purchaseOrderReceiptStatusList[
      LogicConstants.PURCHASEORDER_RECEIPT_APPROVE_STATUS
    ] = "APPROVED";
    this.purchaseOrderReceiptStatusList[
      LogicConstants.PURCHASEORDER_RECEIPT_CANCEL_STATUS
    ] = "CANCELLED";
    return this.purchaseOrderReceiptStatusList;
  };
  static getPurchaseOrderReceiptBeanStatusList = () => {
    let statusList = [];
    return statusList;
  };
  static getPurchaseOrderReceiptStatusCaption = (status) => {
    if (isEmptyString(status)) return "";
    if (this.purchaseOrderReceiptStatusList === undefined) return "";
    return this.purchaseOrderReceiptStatusList[status];
  };
  //#endregion
  static getPurchaseOrderReceiptLineStatusList = () => {
    this.purchaseOrderReceiptLineStatusList = [];
    this.purchaseOrderReceiptLineStatusList[
      LogicConstants.PURCHASEORDER_RECEIPT_LINE_OPEN_STATUS
    ] = "OPEN";

    this.purchaseOrderReceiptLineStatusList[
      LogicConstants.PURCHASEORDER_RECEIPT_LINE_CANCEL_STATUS
    ] = "CANCELLED";
    return this.purchaseOrderReceiptLineStatusList;
  };
  static getPurchaseOrderReceiptLineBeanStatusList = () => {
    let statusList = [];
    return statusList;
  };
  static getPurchaseOrderReceiptLineStatusCaption = (status) => {
    if (isEmptyString(status)) return "";
    if (this.purchaseOrderReceiptLineStatusList === undefined) return "";
    return this.purchaseOrderReceiptLineStatusList[status];
  };
  //#endregion
  static getPurchaseOrderInTransitStatusList = () => {
    this.purchaseOrderInTransitStatusList = [];
    this.purchaseOrderInTransitStatusList[
      LogicConstants.PURCHASEORDER_INTRANSIT_UNAPPROVE_STATUS
    ] = "UNAPPROVED";
    this.purchaseOrderInTransitStatusList[
      LogicConstants.PURCHASEORDER_INTRANSIT_APPROVE_STATUS
    ] = "APPROVED";
    this.purchaseOrderInTransitStatusList[
      LogicConstants.PURCHASEORDER_INTRANSIT_CANCEL_STATUS
    ] = "CANCELLED";
    this.purchaseOrderInTransitStatusList[
      LogicConstants.PURCHASEORDER_INTRANSIT_RECEIVED_STATUS
    ] = "RECEIVED";
    this.purchaseOrderInTransitStatusList[
      LogicConstants.PURCHASE_ORDER_INTRANSIT_PARTIALLY_RECEIVED_STATUS
    ] = "PARTAILLY RECEIVED";
    return this.purchaseOrderInTransitStatusList;
  };
  static getPurchaseOrderInTransitBeanStatusList = () => {
    let statusList = [];
    return statusList;
  };
  static getPurchaseOrderInTransitStatusCaption = (status) => {
    if (isEmptyString(status)) return "";
    if (this.purchaseOrderInTransitStatusList === undefined) return "";
    return this.purchaseOrderInTransitStatusList[status];
  };
  //#endregion
  static getPurchaseOrderInTransitLineStatusList = () => {
    this.purchaseOrderInTransitLineStatusList = [];
    this.purchaseOrderInTransitLineStatusList[
      LogicConstants.PURCHASE_ORDER_INTRANSIT_LINE_OPEN_STATUS
    ] = "OPEN";

    this.purchaseOrderInTransitLineStatusList[
      LogicConstants.PURCHASE_ORDER_INTRANSIT_LINE_CANCEL_STATUS
    ] = "CANCELLED";

    return this.purchaseOrderInTransitLineStatusList;
  };
  static getPurchaseOrderInTransitLineBeanStatusList = () => {
    let statusList = [];
    return statusList;
  };
  static getPurchaseOrderInTransitLineStatusCaption = (status) => {
    if (isEmptyString(status)) return "";
    if (this.purchaseOrderInTransitLineStatusList === undefined) return "";
    return this.purchaseOrderInTransitLineStatusList[status];
  };
  //#endregion.
  static getVendorInvoiceStatusList = () => {
    this.vendorInvoiceStatusList = [];
    this.vendorInvoiceStatusList[LogicConstants.VENDOR_INVOICE_OPEN_STATUS] =
      "OPEN";
    this.vendorInvoiceStatusList[LogicConstants.VENDOR_INVOICE_CANCEL_STATUS] =
      "CANCELLED";
    this.vendorInvoiceStatusList[LogicConstants.VENDOR_INVOICE_PAID_STATUS] =
      "PAID";
    this.vendorInvoiceStatusList[
      LogicConstants.VENDOR_INVOICE_UNAPPROVE_STATUS
    ] = "UNAPPROVED";
    this.vendorInvoiceStatusList[LogicConstants.VENDOR_INVOICE_APPROVE_STATUS] =
      "APPROVED";
    this.vendorInvoiceStatusList[
      LogicConstants.VENDOR_INVOICE_PARTIALLY_PAID_STATUS
    ] = "PARTIALLY PAID";
    return this.vendorInvoiceStatusList;
  };
  static getVendorInvoiceBeanStatusList = () => {
    let statusList = [];
    return statusList;
  };
  static getVendorInvoiceStatusCaption = (status) => {
    if (isEmptyString(status)) return "";
    if (this.vendorInvoiceStatusList === undefined) return "";
    return this.vendorInvoiceStatusList[status];
  };
  //#region  Deposit Status Related
  static getDepositStatusList = () => {
    this.depositStatusList = [];
    this.depositStatusList[LogicConstants.DEPOSIT_OPEN_STATUS] = "OPEN";
    this.depositStatusList[LogicConstants.DEPOSIT_APPROVED_STATUS] = "APPROVED";
    return this.depositStatusList;
  };
  static getDepositBeanStatusList = () => {
    let statusList = [];
    return statusList;
  };
  static getDepositStatusCaption = (status) => {
    if (isEmptyString(status)) return "";
    if (this.depositStatusList === undefined) return "";
    return this.depositStatusList[status];
  };
  //#endregion
  //#region  Bank AdjustMent Status Related
  static getBankAdjustmentStatusList = () => {
    this.bankAdjustmentStatusList = [];
    this.bankAdjustmentStatusList[LogicConstants.BANK_ADJUSTMENT_OPEN_STATUS] =
      "OPEN";
    this.bankAdjustmentStatusList[
      LogicConstants.BANK_ADJUSTMENT_APPROVED_STATUS
    ] = "APPROVED";
    return this.bankAdjustmentStatusList;
  };
  static getBankAdjustmentBeanStatusList = () => {
    let statusList = [];
    return statusList;
  };
  static getBankAdjustmentStatusCaption = (status) => {
    if (isEmptyString(status)) return "";
    if (this.bankAdjustmentStatusList === undefined) return "";
    return this.bankAdjustmentStatusList[status];
  };
  //#endregion
  //#region  Bank AdjustMent Status Related
  static getLetterOfCreditStatusList = () => {
    this.letterOfCreditStatusList = [];
    this.letterOfCreditStatusList[LogicConstants.LETTER_OF_CREDIT_OPEN_STATUS] =
      "OPEN";
    this.letterOfCreditStatusList[
      LogicConstants.LETTER_OF_CREDIT_UNAPPROVED_STATUS
    ] = "UNAPPROVED";
    return this.letterOfCreditStatusList;
  };
  static getLetterOfCreditBeanStatusList = () => {
    let statusList = [];
    return statusList;
  };
  static getLetterOfCreditStatusCaption = (status) => {
    if (isEmptyString(status)) return "";
    if (this.letterOfCreditStatusList === undefined) return "";
    return this.letterOfCreditStatusList[status];
  };
  //#endregion
  //#region  CheckBounce Status Related
  static getCheckBounceStatusList = () => {
    this.checkBounceStatusList = [];
    this.checkBounceStatusList[LogicConstants.CHECK_BOUNCE_OPEN_STATUS] =
      "OPEN";
    this.checkBounceStatusList[LogicConstants.CHECK_BOUNCE_UNAPPROVED_STATUS] =
      "UNAPPROVED";
    this.checkBounceStatusList[LogicConstants.CHECK_BOUNCE_APPROVED_STATUS] =
      "APPROVED";
    return this.checkBounceStatusList;
  };
  static getCheckBounceBeanStatusList = () => {
    let statusList = [];
    return statusList;
  };
  static getCheckBounceStatusCaption = (status) => {
    if (isEmptyString(status)) return "";
    if (this.checkBounceStatusList === undefined) return "";
    return this.checkBounceStatusList[status];
  };
  //#endregion
  //#region CustomerReturn
  static getCustomerReturnStatusList = () => {
    this.customerReturnStatusList = [];
    this.customerReturnStatusList[LogicConstants.CUSTOMER_RETURN_OPEN_STATUS] =
      "OPEN";
    this.customerReturnStatusList[
      LogicConstants.CUSTOMER_RETURN_UNAPPROVE_STATUS
    ] = "UNAPPROVED";
    this.customerReturnStatusList[
      LogicConstants.CUSTOMER_RETURN_APPROVE_STATUS
    ] = "APPROVED";
    this.customerReturnStatusList[
      LogicConstants.CUSTOMER_RETURN_FINISHED_STATUS
    ] = "PAID";
    this.customerReturnStatusList[
      LogicConstants.CUSTOMER_RETURN_CANCEL_STATUS
    ] = "CANCELLED";
    return this.customerReturnStatusList;
  };
  static getCustomerReturnStatusCaption = (status) => {
    if (isEmptyString(status)) return "";
    if (this.customerReturnStatusList === undefined) return "";
    return this.customerReturnStatusList[status];
  };
  //#endRegion
  //#region PreProduction Stage
  static getPreProductionStageStatusList = () => {
    this.preProductionStageStatusList = [];
    this.preProductionStageStatusList[
      LogicConstants.PRE_PRODUCTION_STAGE_OPEN_STATUS
    ] = "OPEN";
    this.preProductionStageStatusList[
      LogicConstants.PRE_PRODUCTION_STAGE_CANCEL_STATUS
    ] = "CANCELLED";
    this.preProductionStageStatusList[
      LogicConstants.PRE_PRODUCTION_STAGE_APPROVE_STATUS
    ] = "APPROVED";
    this.preProductionStageStatusList[
      LogicConstants.PRE_PRODUCTION_STAGE_PARTIALLAY_APPROVE_STATUS
    ] = "PARTIALLAYAPPROVED";
    this.preProductionStageStatusList[
      LogicConstants.PRE_PRODUCTION_STAGE_NOT_APPLICABLE_STATUS
    ] = "N/A";
    this.preProductionStageStatusList[
      LogicConstants.PRE_PRODUCTION_STAGE_FAIL_STATUS
    ] = "FAIL";
    return this.preProductionStageStatusList;
  };
  static getPreProductionStageStatusCaption = (status) => {
    if (isEmptyString(status)) return "";
    if (this.preProductionStageStatusList === undefined) return "";
    return this.preProductionStageStatusList[status];
  };
  //#endRegion
  //#region PreProduction Cycle
  static getPreProductionCycleStatusList = () => {
    this.preProductionCycleStatusList = [];
    this.preProductionCycleStatusList[
      LogicConstants.PRE_PRODUCTION_CYCLE_OPEN_STATUS
    ] = "OPEN";
    this.preProductionCycleStatusList[
      LogicConstants.PRE_PRODUCTION_CYCLE_CANCEL_STATUS
    ] = "CANCELLED";
    this.preProductionCycleStatusList[
      LogicConstants.PRE_PRODUCTION_CYCLE_APPROVE_STATUS
    ] = "APPROVED";
    this.preProductionCycleStatusList[
      LogicConstants.PRE_PRODUCTION_CYCLE_UNAPPROVE_STATUS
    ] = "UNAPPROVED";
    this.preProductionCycleStatusList[
      LogicConstants.PRE_PRODUCTION_CYCLE_SUBMITTED_STATUS
    ] = "SUBMITTED";
    this.preProductionCycleStatusList[
      LogicConstants.PRE_PRODUCTION_CYCLE_RE_SUBMITTED_STATUS
    ] = "RESUBMITTED";
    return this.preProductionCycleStatusList;
  };
  static getPreProductionCycleStatusCaption = (status) => {
    if (isEmptyString(status)) return "";
    if (this.preProductionCycleStatusList === undefined) return "";
    return this.preProductionCycleStatusList[status];
  };
  //#endRegion
  //#region PreProduction
  static getPreProductionStatusList = () => {
    this.preProductionStatusList = [];
    this.preProductionStatusList[LogicConstants.PRE_PRODUCTION_OPEN_STATUS] =
      "OPEN";
    this.preProductionStatusList[LogicConstants.PRE_PRODUCTION_CANCEL_STATUS] =
      "CANCELLED";
    this.preProductionStatusList[LogicConstants.PRE_PRODUCTION_APPROVE_STATUS] =
      "APPROVED";
    this.preProductionStatusList[
      LogicConstants.PRE_PRODUCTION_UNAPPROVE_STATUS
    ] = "UNAPPROVED";
    this.preProductionStatusList[
      LogicConstants.PRE_PRODUCTION_SUBMITTED_STATUS
    ] = "SUBMITTED";
    this.preProductionStatusList[
      LogicConstants.PRE_PRODUCTION_RE_SUBMITTED_STATUS
    ] = "RESUBMITTED";
    this.preProductionStatusList[
      LogicConstants.PRE_PRODUCTION_FINISHED_STATUS
    ] = "FINISHED";
    return this.preProductionStatusList;
  };
  static getPreProductionStatusCaption = (status) => {
    if (isEmptyString(status)) return "";
    if (this.preProductionStatusList === undefined) return "";
    return this.preProductionStatusList[status];
  };
  //#endRegion
  //#region Ecom WebOrder
  static getEcomWebOrderJobStatusList = () => {
    this.ecomWebOrderStatusList = [];
    this.ecomWebOrderStatusList[LogicConstants.DATA_UPLOAD_JOB_FINISH_STATUS] =
      "FINISH";
    this.ecomWebOrderStatusList[LogicConstants.DATA_UPLOAD_JOB_ERROR_STATUS] =
      "ERROR";
    return this.ecomWebOrderStatusList;
  };

  static getEcomWebOrderJobStatusCaption = (status) => {
    if (isEmptyString(status)) return "";
    if (this.ecomWebOrderStatusList === undefined) return "";
    return this.ecomWebOrderStatusList[status];
  };
  //#endRegion
  //#region Logistic Order
  static getLogisticOrderStatusList = () => {
    this.logisticOrderStatusList = [];
    this.logisticOrderStatusList[
      LogicConstants.LOGISTIC_ORDER_UNAPPROVE_STATUS
    ] = "UNAPPROVED";
    this.logisticOrderStatusList[LogicConstants.LOGISTIC_ORDER_APPROVE_STATUS] =
      "APPROVED";
    this.logisticOrderStatusList[LogicConstants.LOGISTIC_ORDER_CANCEL_STATUS] =
      "CANCELLED";
    this.logisticOrderStatusList[
      LogicConstants.LOGISTIC_ORDER_RECEIVED_STATUS
    ] = "RECEIVED";
    this.logisticOrderStatusList[
      LogicConstants.LOGISTIC_ORDER_PARTIALLY_RECEIVED_STATUS
    ] = "PARTIALLY RECEIVED";
    this.logisticOrderStatusList[LogicConstants.LOGISTIC_ORDER_CLOSE_STATUS] =
      "CLOSED";
    return this.logisticOrderStatusList;
  };
  static getLogisticOrderBeanStatusList = () => {
    let statusList = [];
    return statusList;
  };
  static getLogisticOrderStatusCaption = (status) => {
    if (isEmptyString(status)) return "";
    if (this.logisticOrderStatusList === undefined) return "";
    return this.logisticOrderStatusList[status];
  };
  static getLogisticOrderLineStatusList = () => {
    this.logisticOrderLineStatusList = [];
    this.logisticOrderLineStatusList[
      LogicConstants.LOGISTIC_ORDER_LINE_OPEN_STATUS
    ] = "OPEN";
    this.logisticOrderLineStatusList[
      LogicConstants.LOGISTIC_ORDER_LINE_CANCEL_STATUS
    ] = "CANCELLED";
    this.logisticOrderLineStatusList[
      LogicConstants.LOGISTIC_ORDER_LINE_RECEIVED_CANCEL_STATUS
    ] = "RECEIVED CANCEL";
    this.logisticOrderLineStatusList[
      LogicConstants.LOGISTIC_ORDER_LINE_RECEIVED_CLOSE_STATUS
    ] = "RECEIVED CLOSED";
    this.logisticOrderLineStatusList[
      LogicConstants.LOGISTIC_ORDER_LINE_RECEIVED_STATUS
    ] = "RECEIVED";
    this.logisticOrderLineStatusList[
      LogicConstants.LOGISTIC_ORDER_LINE_CLOSE_STATUS
    ] = "CLOSED";
    this.logisticOrderLineStatusList[
      LogicConstants.LOGISTIC_ORDER_LINE_PARTIALLY_RECEIVED_STATUS
    ] = "PARTIALLY RECEIVED";

    return this.logisticOrderLineStatusList;
  };
  static getLogisticOrderLineBeanStatusList = () => {
    let statusList = [];
    return statusList;
  };
  static getLogisticOrderLineStatusCaption = (status) => {
    if (isEmptyString(status)) return "";
    if (this.logisticOrderLineStatusList === undefined) return "";
    return this.logisticOrderLineStatusList[status];
  };
  //endregion

  //#region Logistic Order
  static getLogisticOrderReceiptStatusList = () => {
    this.logisticOrderReceiptStatusList = [];
    this.logisticOrderReceiptStatusList[
      LogicConstants.LOGISTIC_ORDER_RECEIPT_UNAPPROVE_STATUS
    ] = "UNAPPROVED";
    this.logisticOrderReceiptStatusList[
      LogicConstants.LOGISTIC_ORDER_RECEIPT_CANCEL_STATUS
    ] = "CANCELLED";
    this.logisticOrderReceiptStatusList[
      LogicConstants.LOGISTIC_ORDER_RECEIPT_APPROVE_STATUS
    ] = "APPROVED";
    return this.logisticOrderReceiptStatusList;
  };
  static getLogisticOrderReceiptBeanStatusList = () => {
    let statusList = [];
    return statusList;
  };
  static getLogisticOrderReceiptStatusCaption = (status) => {
    if (isEmptyString(status)) return "";
    if (this.logisticOrderReceiptStatusList === undefined) return "";
    return this.logisticOrderReceiptStatusList[status];
  };
  static getLogisticOrderReceiptLineStatusList = () => {
    this.logisticOrderReceiptLineStatusList = [];
    this.logisticOrderReceiptLineStatusList[
      LogicConstants.LOGISTIC_ORDER_RECEIPT_LINE_OPEN_STATUS
    ] = "OPEN";
    this.logisticOrderReceiptLineStatusList[
      LogicConstants.LOGISTIC_ORDER_RECEIPT_LINE_CANCEL_STATUS
    ] = "CANCELLED";
    this.logisticOrderReceiptLineStatusList[
      LogicConstants.LOGISTIC_ORDER_RECEIPT_LINE_CLOSE_STATUS
    ] = "CLOSED";

    return this.logisticOrderReceiptLineStatusList;
  };
  static getLogisticOrderReceiptLineBeanStatusList = () => {
    let statusList = [];
    return statusList;
  };
  static getLogisticOrderReceiptLineStatusCaption = (status) => {
    if (isEmptyString(status)) return "";
    if (this.logisticOrderReceiptLineStatusList === undefined) return "";
    return this.logisticOrderReceiptLineStatusList[status];
  };
  //endregion
  //#region Invoice Service Line
  static getInvoiceServiceLineStatusList = () => {
    this.invoiceServiceLineStatusList = [];
    this.invoiceServiceLineStatusList[
      LogicConstants.INVOICE_SERVICE_LINE_OPEN_STATUS
    ] = "OPEN";
    this.invoiceServiceLineStatusList[
      LogicConstants.INVOICE_SERVICE_LINE_CANCEL_STATUS
    ] = "CANCELLED";
    return this.invoiceServiceLineStatusList;
  };
  static getInvoiceServiceLineStatusCaption = (status) => {
    if (isEmptyString(status)) return "";
    if (this.invoiceServiceLineStatusList === undefined) return "";
    return this.invoiceServiceLineStatusList[status];
  };

  //#region Post Dated Order
  static getPostDatedCheckEntryStatusList = () => {
    this.postDatedCheckStatusList = [];
    this.postDatedCheckStatusList[
      LogicConstants.POST_DATED_CHECKENTRY_UNAPPROVE_STATUS
    ] = "UNAPPROVED";
    this.postDatedCheckStatusList[
      LogicConstants.POST_DATED_CHECKENTRY_APPROVE_STATUS
    ] = "APPROVED";
    this.postDatedCheckStatusList[
      LogicConstants.POST_DATED_CHECKENTRY_CANCEL_STATUS
    ] = "CANCELLED";
    this.postDatedCheckStatusList[
      LogicConstants.POST_DATED_CHECKENTRY_FINISHED_STATUS
    ] = "FINISHED";

    this.postDatedCheckStatusList[
      LogicConstants.POST_DATED_CHECKENTRY_OPEN_STATUS
    ] = "OPEN";
    return this.postDatedCheckStatusList;
  };
  static getPostDatedCheckEntryBeanStatusList = () => {
    let statusList = [];
    return statusList;
  };
  static getPostDatedCheckEntryStatusCaption = (status) => {
    if (isEmptyString(status)) return "";
    if (this.postDatedCheckStatusList === undefined) return "";
    return this.postDatedCheckStatusList[status];
  };
  

  static getDateFormat = (inputDate) => {
    if (isEmptyString(inputDate)) return "";

    var dateParts = inputDate.split("-");
    var finalDate = dateParts[1] + "-" + dateParts[2] + "-" + dateParts[0];
    return finalDate;
  };
  
  static getDateFormat_v1 = (inputDate) => {
    if (isEmptyString(inputDate)) return "";
    let temp_date = moment(inputDate).utc().toDate();

    //let temp_date = new Date(inputDate);

    let day =  temp_date.toLocaleDateString('en-us', {day: 'numeric'});
    let month = temp_date.toLocaleDateString('en-us', {month: 'numeric'});
    let year = temp_date.toLocaleDateString('en-us', {year: 'numeric'}) ;
    
    //const finalDate = `${month}-${day}-${year}`
    const finalDate = `${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}-${year}`;

    //var dateParts = inputDate.split("-");
    //var finalDate = dateParts[1] + "-" + dateParts[2] + "-" + dateParts[0];
    return finalDate;
  };  
 
  
//#region CPM
   static getCpmStatusList = () => {
    this.cpmStatusList = [];
    this.cpmStatusList[
      LogicConstants.CRITICAL_PATH_MANAGEMENT_UNAPPROVE_STATUS 
    ] = "UNAPPROVED";
    this.cpmStatusList[LogicConstants.CRITICAL_PATH_MANAGEMENT_APPROVE_STATUS ] =
      "APPROVED";
    this.cpmStatusList[LogicConstants.CRITICAL_PATH_MANAGEMENT_CANCEL_STATUS] =
      "CANCELLED";
    this.cpmStatusList[
      LogicConstants.CRITICAL_PATH_MANAGEMENT_CLOSE_STATUS 
    ] = "FINISHED";
    this.cpmStatusList[
      LogicConstants.CRITICAL_PATH_MANAGEMENT_OPEN_STATUS 
    ] = "OPEN";
    return this.cpmStatusList;
  };
  static getCpmStatusCaption = (status) => {
    if (isEmptyString(status)) return "";
    if (this.cpmStatusList === undefined) return "";
    return this.cpmStatusList[status];
  };
  static cpmLinesStatusList = () => {
    this.cpmLineStatusList = [];
    this.cpmLineStatusList[
      LogicConstants.CRITICAL_PATH_MANAGEMENT_LINE_OPEN_STATUS 
    ] = "OPEN";
    this.cpmLineStatusList[
      LogicConstants.CRITICAL_PATH_MANAGEMENT_LINE_CANCEL_STATUS
    ] = "CANCELLED";
    this.cpmLineStatusList[
      LogicConstants.CRITICAL_PATH_MANAGEMENT_LINE_APPROVED_STATUS 
    ] = "APPROVED";
    this.cpmLineStatusList[
      LogicConstants.CRITICAL_PATH_MANAGEMENT_LINE_REJECTED_STATUS 
    ] = "REJECTED";
    this.cpmLineStatusList[
      LogicConstants.CRITICAL_PATH_MANAGEMENT_LINE_EXCLUDED_STATUS
    ] = "EXCLUDED";
    this.cpmLineStatusList[
      LogicConstants.CRITICAL_PATH_MANAGEMENT_LINE_FINISHED_STATUS 
    ] = "FINISHED";
    this.cpmLineStatusList[
      LogicConstants.CRITICAL_PATH_MANAGEMENT_LINE_CLOSE_STATUS 
    ] = "CLOSED";
  
    return this.cpmLineStatusList;
  };

  
  static getCpmLineStatusCaption = (status) => {
    if (isEmptyString(status)) return "";
    if (this.cpmLineStatusList === undefined) return "";
    return this.cpmLineStatusList[status];
  };
  //endregion



  static getPurchaseOrderPaymentStatusList = () => {
    this.purchaseOrderPaymentStatusList = [];
    this.purchaseOrderPaymentStatusList[
      LogicConstants.PURCHASE_ORDER_PAYMENT_OPEN_STATUS 
    ] = "OPEN";
    this.purchaseOrderPaymentStatusList[
      LogicConstants.PURCHASE_ORDER_PAID_STATUS
    ] = "PAID";
    this.purchaseOrderPaymentStatusList[
      LogicConstants.PURCHASE_ORDER_PARTIALLY_PAID_STATUS 
    ] = "PARTIALLY PAID";

    return this.purchaseOrderPaymentStatusList;
  };

  
  static getPurchaseOrderPaymentStatusCaption = (status) => {
    if (isEmptyString(status)) return "";
    if (this.purchaseOrderPaymentStatusList === undefined) return "";
    return this.purchaseOrderPaymentStatusList[status];
  };




  static getPurchaseOrderReceiptPaymentStatusList = () => {
    this.purchaseOrderReceiptPaymentStatusList = [];
    this.purchaseOrderReceiptPaymentStatusList[
      LogicConstants.PURCHASE_ORDER_RECEIPT_PAYMENT_OPEN_STATUS 
    ] = "OPEN";
    this.purchaseOrderReceiptPaymentStatusList[
      LogicConstants.PURCHASE_ORDER_RECEIPT_PAID_STATUS
    ] = "PAID";
    this.purchaseOrderReceiptPaymentStatusList[
      LogicConstants.PURCHASE_ORDER_RECEIPT_PARTIALLY_PAID_STATUS 
    ] = "PARTIALLY PAID";

    return this.purchaseOrderReceiptPaymentStatusList;
  };

  
  static getPurchaseOrderReceiptPaymentStatusCaption = (status) => {
    if (isEmptyString(status)) return "";
    if (this.purchaseOrderReceiptPaymentStatusList === undefined) return "";
    return this.purchaseOrderReceiptPaymentStatusList[status];
  };

static getDebitMemoStatusList = () => {
    this.debitMemoStatusList = [];
    this.debitMemoStatusList[
      LogicConstants.DEBIT_MEMO_OPEN_STATUS
    ] = "OPEN";
    this.debitMemoStatusList[
      LogicConstants.DEBIT_MEMO_APPROVE_STATUS
    ] = "APPROVED";
    this.debitMemoStatusList[
      LogicConstants.DEBIT_MEMO_CANCEL_STATUS
    ] = "CANCEL";
    this.debitMemoStatusList[
      LogicConstants.DEBIT_MEMO_FINISHED_STATUS
    ] = "FINISH";
    this.debitMemoStatusList[
      LogicConstants.DEBIT_MEMO_PARTIALLY_CLOSED_STATUS
    ] = "PARTIALLY CLOSED";
    this.debitMemoStatusList[
      LogicConstants.DEBIT_MEMO_PARTIALLY_USED_AND_APPROVED_STATUS
    ] = "PARTIALLYUSEDAPPROVED";

    return this.debitMemoStatusList;
  };


  static getDebitMemoStatusCaption = (status) => {
    if (isEmptyString(status)) return "";
    if (this.debitMemoStatusList === undefined) return "";
    return this.debitMemoStatusList[status];
  };



  static getDebitMemoLinesStatusList = () => {
    this.debitMemoLineStatusList = [];
    this.debitMemoLineStatusList[
      LogicConstants.DEBIT_MEMO_LINE_OPEN_STATUS
    ] = "OPEN";
    this.debitMemoLineStatusList[
      LogicConstants.DEBIT_MEMO_LINE_APPROVE_STATUS
    ] = "APPROVE";
    this.debitMemoLineStatusList[
      LogicConstants.DEBIT_MEMO_LINE_CANCEL_STATUS
    ] = "CANCEL";
    return this.debitMemoLineStatusList;
  };


  static getDebitMemoLineStatusCaption = (status) => {
    if (isEmptyString(status)) return "";
    if (this.debitMemoLineStatusList === undefined) return "";
    return this.debitMemoLineStatusList[status];
  };



 static getDebitMemoTrackStatusList = () => {
    this.debitMemoTrackStatusList = [];
    this.debitMemoTrackStatusList[
      LogicConstants.DEBIT_MEMO_CREATE_TRACK_TYPE
    ] = "CREATE";
    this.debitMemoTrackStatusList[
      LogicConstants.DEBIT_MEMO_UPDATE_TRACK_TYPE
    ] = "UPDATE";
    this.debitMemoTrackStatusList[
      LogicConstants.DEBIT_MEMO_APPROVE_TRACK_TYPE
    ] = "APPROVE";
    this.debitMemoTrackStatusList[
      LogicConstants.DEBIT_MEMO_CANCEL_TRACK_TYPE
    ] = "CANCEL";
        this.debitMemoTrackStatusList[
      LogicConstants.DEBIT_MEMO_FINISH_TRACK_TYPE
    ] = "FINISH";
        this.debitMemoTrackStatusList[
      LogicConstants.DEBIT_MEMO_CLOSE_STATUS
    ] = "CLOSED";
    return this.debitMemoTrackStatusList;
  };

  static getDebitMemoTrackStatusCaption = (status) => {
    if (isEmptyString(status)) return "";
    if (this.debitMemoTrackStatusList === undefined) return "";
    return this.debitMemoTrackStatusList[status];
  };

static isActiveAttribute = (list) => {
    
     let attributesList = [];
    if (isEmptyArray(list)) return attributesList;

    attributesList = list.filter(
      (listData) => listData.isActive
    );
    return attributesList;
  };  
  
}
